import React, { useState, useContext } from 'react'
import { Menu, Icon, Button, Modal } from 'semantic-ui-react'
import { GlobalContext } from 'globalContext'
import history from 'services/history'
import './Header.scss'

export default function Header({ toogleSidebar, sidebarVisible }) {

    const [global, setGlobal] = useContext(GlobalContext)
    const [open, setOpen] = useState(false);

    const logout = () => {
        localStorage.removeItem('JWTR');
        setGlobal({
            type: 'reset'
        });
        history.push('/restaurante')
    }

    const close = () => {
        setOpen(false);
    }

    return (
        <div id='header-restaurante'>
            <Menu className='system-menu d-print-none fixed-top'>
                <Menu.Item as="a" onClick={() => toogleSidebar(!sidebarVisible)}>
                    <Icon style={{ fontWeight: 'bolder' }} name="bars" />
                </Menu.Item>
                <Menu.Menu position='right'>
                    <Menu.Item className='user mr-4' as="span" style={{ padding: 0 }}>
                        <Icon name="user" /> {global.userRest.nome}
                    </Menu.Item>
                    <Menu.Item style={{ padding: 0 }}>
                        <Button title='Sair' className='buttonSair' size='tiny' onClick={() => { setOpen(true) }}>
                            <Icon name='sign-out' style={{ color:'#ed722f' }} />
                        </Button>
                    </Menu.Item>
                </Menu.Menu>
            </Menu>

            <Modal size='mini' open={open} onClose={close}>
                <Modal.Header>Sair</Modal.Header>
                <Modal.Content>
                    <p>Tem certeza que deseja sair?</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative onClick={() => { setOpen(false) }}>Não</Button>
                    <Button
                        onClick={() => logout()}
                        positive
                        icon='checkmark'
                        labelPosition='right'
                        content='Sim'
                    />
                </Modal.Actions>
            </Modal>

        </div>
    )
}
